import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IPricesState } from "./slice";
import { getPricesAsync } from "./actions";

type Reducer = (builder: ActionReducerMapBuilder<IPricesState>) => void;

export const getPricesReducer: Reducer = (builder) => {
  builder.addCase(getPricesAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getPricesAsync.fulfilled, (state, actions) => {
    state.isLoading = false;
    state.data = actions.payload;
  });

  builder.addCase(getPricesAsync.rejected, (state) => {
    state.isLoading = false;
    state.data = [];
  });
};
